import { gd } from "../../../../date-fns/locale/gd.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    gd
  }
};